import {
  Builder,
  PerformActionResponse,
  performActionTransformResponse,
} from 'src/store/APIs/types'

import { Endpoints, Me } from './types'

export const me = (builder: Builder) =>
  builder.query<Me, void>({
    query: () => Endpoints.Me,
  })

export const changePassword = (builder: Builder) =>
  builder.mutation<
    PerformActionResponse,
    { password: string; current_password: string }
  >({
    query: ({ password, current_password }) => ({
      body: { current_password, password },
      method: 'PATCH',
      url: Endpoints.ChangePassword,
    }),
    transformResponse: performActionTransformResponse,
  })
